import { render } from "./Marker.vue?vue&type=template&id=5b98d41e&scoped=true"
const script = {}

import "./Marker.vue?vue&type=style&index=0&id=5b98d41e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b98d41e"]])

export default __exports__